// Required for navigating the challenge page
const JUST_REGISTERED = 'just-registered'
let cfFormEl = null
let cfFormApi = null

const setMarketingDefaults = () => {
  // set the value of marketing comms to true by default per client request
  // refer to documentation: https://developers.customerfields.com/front-end-api/form-api/
  cfFormApi.setFieldValue('manage_communications', ['method~email'])
}

const afterSubmitSuccess = (event) => {
  if (!event.detail) {
    console.warn('No event.detail on submit', event)
    return
  }
  const { formId, submissionData } = event.detail
  console.log('onSubmit', formId, submissionData, event.target)
}

const onSubmitFailed = (event) => {
    if (!event.detail) {
        console.warn('No event.detail on submit failed', event)
        return
    }
    const {formId, errors} = event.detail

    if (errors.phone && errors.phone[0] === 'has already been taken') {
        observerErrorPhone()
    }
}

const observerErrorPhone = () => {
    // Select the node that will be observed for mutations
    const targetNode = document.querySelector('.cf-form-actions')

    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: false }

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
                const validEl = document.querySelector('.cf-step-invalid')
                const messageEl = validEl.querySelector('.cf-form-errors li')
                if(validEl && messageEl){
                    messageEl.innerHTML = `An existing account has been found. Please call <a href="tel:1800 800 866">1800 800 866</a> for assistance activating your account.`
                    observer.disconnect()
                }
            }
        }
    }

    const observer = new MutationObserver(callback)
    observer.observe(targetNode, config)
}

const verifyAddressRegister = async (formEl) => {
    let address1 = formEl.cfForm.getFieldValue('default_address.address1')
    let address2 = ''
    let city = formEl.cfForm.getFieldValue('default_address.city')
    let state = formEl.cfForm.getFieldValue('default_address.province')
    let postcode = formEl.cfForm.getFieldValue('default_address.zip')
    let data

    try {
      const resJson = await fetch(`/apps/kleber/api/repairAddress?address1=${address1}&address2=${address2}&city=${city}&state=${state}&postcode=${postcode}`)
      const res = await resJson.json()
      data = res.DtResponse.Result[0];
          /**
       * data is an object with the following structure 
       * {
          "DPID": "87878933",
          "BuildingName": "",
          "AddressLine": "100 Rupert St",
          "Locality": "COLLINGWOOD",
          "State": "VIC",
          "Postcode": "3066",
          "AddressBlockLine1": "100 Rupert St",
          "AddressBlockLine2": "COLLINGWOOD VIC 3066",
          "AddressBlockLine3": "",
          "AddressBlockLine4": "",
          "AddressBlockLine5": "",
          "AddressBlockLine6": "",
          "AddressBlockLine7": "",
          "MatchType": "0",
          "MatchTypeDescription": "Correct",
          "FieldChanges": "",
          "ConfidenceScore": "0,0,0,0",
          "AllocationFlag": "L-EXACT L-NAMEXACT S-EXACT S-NAMEXACT P-NUMOK",
          "AustraliaPostBarcode": "1301012221222122301010321122021220213",
          "AustraliaPostBarcodeSortPlan": "026",
          "UnitType": "",
          "UnitNumber": "",
          "LevelType": "",
          "LevelNumber": "",
          "LotNumber": "",
          "StreetNumber1": "100",
          "StreetNumberSuffix1": "",
          "StreetNumber2": "",
          "StreetNumberSuffix2": "",
          "PostBoxNumber": "",
          "PostBoxNumberPrefix": "",
          "PostBoxNumberSuffix": "",
          "StreetName": "Rupert",
          "StreetType": "St",
          "StreetSuffix": "",
          "PostBoxType": "",
          "AltStreetName": "Rupert",
          "AltStreetType": "St",
          "AltStreetSuffix": "",
          "AltLocality": "COLLINGWOOD",
          "AltState": "VIC",
          "AltPostcode": "3066",
          "UnknownData": ""
          }
          // data.ConfidenceScore === '0,0,0,0' suggests all match
          // data.MatchTypeDescription === 'Correct' can return Correct even if partially correct
    */
    } catch (err) {
      console.error('Error validating address', err)
      return false
    }

    if (!data) return false

    if (data.MatchTypeDescription === 'Correct' && data.ConfidenceScore === '0,0,0,0') {
      return true
    } else {
      return false
    }
}

const validateAddress = async () => {
  const formEl = document.querySelector('form[data-cf-form]')
  const passed = await verifyAddressRegister(formEl)
  return passed
}

const getAddress = async (fieldValue) => {
  // Prevent infinitely suggesting addresses
  if (fieldValue === previousAddressValue) return;

  let data

  try {
    const resJson = await fetch(`/apps/kleber/api/searchAddress?address=${fieldValue}&limit=5`)
    const res = await resJson.json()
    data = res?.DtResponse?.Result;
  } catch (err) {
    console.error('Error fetching or processing address data:', err);
    return
  }

  if (!data || data.length === 0) return;

  // Select relevant DOM elements
  const addressField = document.querySelector('.cf-address-field');
  const resultContainerParent = document.querySelector('.cf-field-container.address-search-result-container');
  resultContainerParent.style.top = `${addressField.offsetTop + 72}px`;
  const resultContainer = document.querySelector('.cf-field.address-search-result-container');
  
  // DOM Update
  resultContainer.innerHTML = '';

  data.forEach(function (record) {
    const item = document.createElement('button');
    item.setAttribute('id', record.RecordId);
    item.classList.add('autocomplete-suggestion');
    item.addEventListener('click', function (e) {
      previousAddressValue = record.AddressLine;
      e.preventDefault();
      setAddress(e.target.id);
    });
    item.innerHTML = `${record.AddressLine}, ${record.Locality}, ${record.State}`;
    resultContainer.appendChild(item);
  });

  // Show the result container
  resultContainerParent.classList.add('active');
}

const setAddress = async (addressId) => {
  let res

  try {
    const resJson = await fetch(`/apps/kleber/api/retrieveAddress?addressId=${addressId}`)
    res = await resJson.json()
  } catch (err) {
    console.error('Error validating address', err)
    return false
  }

  // Early Exist if no data
  if (!(res?.DtResponse?.Result?.length > 0)) return;

  // Select relevant DOM elements
  const resultContainerParent = document.querySelector('.cf-field-container.address-search-result-container')
  const resultContainer = document.querySelector('.cf-field.address-search-result-container')

  // DOM Update
  resultContainer.innerHTML = '';
  resultContainerParent.classList.remove('active');

  const data = res.DtResponse.Result[0];
  if (data) {
    const address = data.AddressLine;
    const city = data.Locality;
    const state = data.State;
    const zip = data.Postcode;
    const country = 'Australia';

    cfFormApi.setFieldValue('default_address.address1', address)
    cfFormApi.setFieldValue('default_address.city', city)
    cfFormApi.setFieldValue('default_address.zip', zip)
    cfFormApi.setFieldValue('default_address.country', country)
    cfFormApi.setFieldValue('default_address.province', state)
  }
}

// Init Variables
let previousAddressValue = '' // This is to check if the address has changed to prevent infinite address suggestion
// These have to be in a global variable due to CF Form limitations
window.validateAddress = validateAddress
window.getAddress = getAddress
window.toggleRequiredFields = (fieldValue) => {
  const phoneNumberFields = document.querySelectorAll('.data-cf-cd-phone-number')
  const addressFields = document.querySelectorAll('.data-cf-cd-form')

  if (!phoneNumberFields || !addressFields) return true
  
  if (fieldValue.includes('method~sms')) { 
    phoneNumberFields.forEach(field => field.classList.remove('hidden'))
  } else if (!fieldValue.includes('method~sms')){
    cfFormApi.setFieldValue('phone', '')
    phoneNumberFields.forEach(field => field.classList.add('hidden'))
  }

  if (fieldValue.includes('method~post')) {
    addressFields.forEach(field => field.classList.remove('hidden'))
  } else if (!fieldValue.includes('method~post')) {
    const resetFields = ['default_address.address1', 'default_address.city', 'default_address.zip', 'default_address.country', 'default_address.province']
    resetFields.forEach(fieldName => cfFormApi.setFieldValue(fieldName, ''))
    addressFields.forEach(field => field.classList.add('hidden'))
  }

  return true
}

const initCfFormBehaviours = () => {
    CF.ready(() => {
        var $myForm = document.querySelector('form[data-cf-form]');
        cfFormEl = $myForm
        cfFormApi = $myForm.cfForm
        
        setMarketingDefaults()
        cfFormEl.addEventListener('cf:form_submitted', afterSubmitSuccess)
        cfFormEl.addEventListener('cf:form_submission_failed', onSubmitFailed)
        cfFormEl.addEventListener('cf:beforeSave', async () => { window.validateAddress()})

        // A seperate validation has been run due to us requiring to run validation on each seperate field
        // The integration of the autocomplete should remedy some weird field validation functionality
        const getAddress = {
            // This has to take in fieldValue as a parameter even if it is not consumed
            comparator: async function(fieldValue) {
                await window.getAddress(fieldValue);
                // Always return true just to prevent errors from running since isn't actually a validator
                return true
            },
            errorMessage: '', 
            async: true
        }
        const validationStreet = {
            // This has to take in fieldValue as a parameter even if it is not consumed
            comparator: async function(fieldValue) {
                return await window.validateAddress();
            },
            errorMessage: 'Please check your address is correct', 
            async: true
        }
        const validationProvince = {
            // This has to take in fieldValue as a parameter even if it is not consumed
            comparator: async function(fieldValue) {
                return await window.validateAddress();
            },
            errorMessage: 'Please check your city is correct', 
            async: true             
        }
        const validationZip = {
            // This has to take in fieldValue as a parameter even if it is not consumed
            comparator: async function(fieldValue) {
                return await window.validateAddress();
            },
            errorMessage: 'Please check your zipcode is correct', 
            async: true  
        }
        const validationCity = {
            // This has to take in fieldValue as a parameter even if it is not consumed
            comparator: async function(fieldValue) {
                return await window.validateAddress();
            },
            errorMessage: 'Please check your state is correct', 
            async: true  
        }
        const smsField = {
            // This has to take in fieldValue as a parameter even if it is not consumed
            comparator: async function(fieldValue) {
              return window.toggleRequiredFields(fieldValue)
          },
          errorMessage: 'Please tick at least one box', 
          async: true
        }
        // This calls for auto-complete, which only runs on address field
        cfFormApi.addValidator(getAddress, 'default_address.address1')
        cfFormApi.addValidator(validationStreet, 'default_address.address1')
        cfFormApi.addValidator(validationCity, 'default_address.city')
        cfFormApi.addValidator(validationZip, 'default_address.zip')
        cfFormApi.addValidator(validationProvince, 'default_address.province')
        cfFormApi.addValidator(smsField, 'manage_communications')
    })
}

document.addEventListener('DOMContentLoaded', initCfFormBehaviours)